<template>
    <div class="topicNav">
        <div
            class="topicNavItem"
            :class="{ cur: navItem.beSelected }"
            v-for="(navItem, navIndex) in topicItem.buttonInfes"
            :key="navIndex"
            @click="comChangeTopicNav(navItem.caption, navIndex)"
        >
            {{ navItem.caption }}
        </div>
        <i class="solid" :style="{transform: 'translateX('+ solidLeft +'px)'}"></i>
    </div>
</template>

<script>
export default {
    name: "ListNav",
    props: {
        topicItem: Object
    },
    data() {
        return {
            solidLeft: 0
        };
    },
    mounted() {
        this.$nextTick(() => {
            let tabDomList = document.getElementsByClassName("topicNavItem");
            let domWidth = tabDomList[0].offsetWidth;
            this.solidLeft = 16 + Math.floor(Number(domWidth) / 2) - 8;
        });
    },
    methods: {
        comChangeTopicNav(caption, navIndex) {
            let tabDomList = document.getElementsByClassName("topicNavItem");
            let domWidth = tabDomList[navIndex].offsetWidth;
            let allWidth = 0;
            for (let i = 0; i < navIndex; i++) {
                allWidth += tabDomList[i].offsetWidth;
            }
            this.solidLeft = 16 + allWidth + Math.floor(Number(domWidth) / 2) - 8 + (navIndex * 22);
            this.$emit("changeTopicNav", caption);
        }
    },
    components: {}
};
</script>

<style lang="scss" scoped>
.topicNav {
    position: relative;
    width: 100%;
    height: 44px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    box-sizing: border-box;
    .topicNavItem {
        position: relative;
        height: 22px;
        line-height: 22px;
        font-size: 15px;
        font-weight: 500;
        @include Color2($Color2);
        margin-right: 22px;
        cursor: pointer;
        &:last-child {
            margin-right: 0;
        }
        &.cur {
            @include newsContentColor($newsContentColor);
            // &::before {
            //     content: "";
            //     display: block;
            //     position: absolute;
            //     left: 50%;
            //     bottom: -2px;
            //     transform: translateX(-50%);
            //     width: 16px;
            //     height: 3px;
            //     border-radius: 2px;
            //     background: #eb413d;
            // }
        }
    }
    .solid {
        position: absolute;
        left: 0;
        transform: translateX(38px);
        bottom: 6px;
        display: block;
        width: 16px;
        height: 3px;
        border-radius: 2px;
        background: #eb413d;
        transition: all .3s;
    }
}
</style>